import { CSSProperties, FC } from 'react';
import StarRating from '../../components/shared/Rating';
import { EvaluationLimits } from '../../util/evaluationContract';
import styles from './page-supplier-evaluations.module.scss';

type StarRatingProps = {
  className?: string;
  rating: number;
  numberOfStars: number;
  readOnly?: boolean;
  noNumber?: boolean;
  style?: CSSProperties;
};

const TypedStarRating = StarRating as unknown as FC<StarRatingProps>;

type Props = {
  rating: number;
  size?: number;
};

const ReadOnlyStars: FC<Props> = ({ rating, size = 14 }) => (
  <TypedStarRating
    className={`rating-component ${styles.stars}`}
    style={{ fontSize: size }}
    rating={rating}
    numberOfStars={EvaluationLimits.ScaleMax}
    readOnly
    noNumber
  />
);

export default ReadOnlyStars;
